import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/organizations")({
  staticData: { title: "Organizations" },
  component: () => <Outlet />,
});
